import styled from "styled-components";
import {flexAdaptiveSizeItem} from "../../../../themes/architecture/css-helpers/flex";

export const IndicatorContainerBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 1.5rem;
    ${flexAdaptiveSizeItem}
    overflow-x: hidden;
    font-family: ${props => props.theme.font.family.regular};
    ${props => props.theme.font.presets.regular}

`;
